import { InstantRakeback, Reward, RewardsClaimModal, RewardsList } from "@housebets/housebets-x-package";
import VipReload from "../../legacy/VipReload";
import { IRewardListProps } from "./types";
import { useRewardListData } from "../hooks/useRewardListData";

export const RewardList: React.FC<IRewardListProps> = ({
    type
}) => {
    const {
        InstantData,
        DailyData,
        WeeklyData,
        MonthData,
        ReloadData,
        LevelUpData,
        modal2Type,
        isOpenModal2,
        setIsOpenModal2,
        ClaimData,
        id,
        setId,
        vipReloadModalOpen,
        receiveManualBonus,
        setVipReloadModalOpen,
        vipReloadData,
        claimHandler,
        level,
        isLevelUpClaimed,
        isSomeAvailable,
    } = useRewardListData(null);

    return (
        <>
            <RewardsList>
                {(type === 'all' || InstantData.canClaim) && <Reward buttonV2 {...InstantData} />}
                {(type === 'all' || DailyData.canClaim) && <Reward buttonV2 {...DailyData} />}
                {(type === 'all' || WeeklyData.canClaim) && level >= 7 && <Reward buttonV2 {...WeeklyData} />}
                {(LevelUpData.canClaim || isLevelUpClaimed) && level >= 7 && <Reward buttonV2 {...LevelUpData} />}
                {ReloadData.canClaim && level >= 7 && <Reward buttonV2 {...ReloadData} />}
                {(type === 'all' || MonthData.canClaim) && level >= 17 && <Reward buttonV2 {...MonthData} />}
            </RewardsList>
            {type === 'available' && !isSomeAvailable
                && (
                    <div
                        style={{
                            display: 'flex',
                            fontFamily: 'Roobert',
                            justifyContent: 'center',
                            padding: '0 20px 20px'
                        }}
                    >
                        There are no available rewards
                    </div>
                )
            }

            <RewardsClaimModal
                title={
                    modal2Type === "daily"
                        ? "Daily Rakeback"
                        : modal2Type === "week"
                            ? "Weekly Reload"
                            : modal2Type === "month"
                                ? "Monthly reload"
                                : modal2Type === "instant"
                                    ? "Instant Rakeback"
                                    : modal2Type === 'level'
                                        ? 'Level Up'
                                        : ""
                }
                isOpen={isOpenModal2}
                onClose={() => setIsOpenModal2(false)}
            >
                <InstantRakeback
                    {...ClaimData}
                    selectedCurrency={id}
                    onCurrencyChange={(v) => setId(v)}
                    onClick={claimHandler}
                    v2
                />
            </RewardsClaimModal>

            <RewardsClaimModal
                title="Vip reload"
                isOpen={vipReloadModalOpen}
                onClose={() => setVipReloadModalOpen(false)}
            >
                <VipReload {...vipReloadData} onClick={receiveManualBonus} />
            </RewardsClaimModal>
        </>
    );
}

RewardList.displayName = 'RewardList'